import { Component, computed, inject, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';

import { CTA } from '@ppg/core/models';
import { UrlCtaService } from '@ppg/shared/utils';

@Component({
  selector: 'ppg-container-content-banner-cta',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './container-content-banner-cta.component.html',
  styleUrl: './container-content-banner-cta.component.scss',
})
export class ContainerContentBannerCtaComponent {
  readonly cta = input.required<CTA | undefined>();

  readonly #urlCtaService: UrlCtaService = inject(UrlCtaService);

  readonly icon = computed(() => (this.#urlCtaService.isTargetBlank(this.cta()) ? 'pi pi-arrow-up-right' : undefined));

  navigateTo(): void {
    this.#urlCtaService.navigate(this.cta());
  }
}
